<script lang="ts">
  import { getCopy } from "../../lib/stores/copy";
  import BaseStep from "./BaseStep.svelte";
  import SharedHeading from "../SharedHeading.svelte";
  import Youtube from "../Youtube.svelte";

  export let currentRoute;

  $: copy = $getCopy("campaignTeaser") as Record<string, string>;
</script>

<BaseStep {currentRoute}>
  <svelte:fragment slot="content">
    <SharedHeading headerCopy={copy.headerCopy} subHeaderCopy={copy.subHeaderCopy} />
    {#if copy.customHtml}
      {@html copy.customHtml}
    {/if}
    <Youtube videoId={copy.videoId} />
  </svelte:fragment>
</BaseStep>
